import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { CountryDto } from '../../../../core/data/dtos/country.dto';
import { StateDto } from '../../../../core/data/dtos/state.dto';
import { ZipFullDescDto } from '../../../../core/data/dtos/zip-full-desc.dto';
import { SearchableDropdownComponent } from '../../../../common/components/searchable-dropdown/searchable-dropdown.component';

@Component({
    selector: 'app-checkout-contact',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective, SearchableDropdownComponent],
    templateUrl: './checkout-contact.component.html',
})
export class CheckoutContactComponent {
    @Input() form!: FormGroup;
    @Input() countries: CountryDto[] = [];
    @Input() filteredStates: StateDto[] = [];
    @Input() filteredZipFullDescs: ZipFullDescDto[] = [];

    @Output() countryChange = new EventEmitter<number | null>();
    @Output() stateChange = new EventEmitter<number | null>();
}
